import { capitalize } from "lodash";
import * as React from "react";
import { useParams } from "react-router";
import { useCheckEventAccess } from "src/components/Event/useCheckEventAccess";
import { useGetEventDetailQuery } from "src/queries/useGetEventDetailQuery";
import { formatTitleHeader } from "src/utils/formatUtils";
import EventInfoSections from "./EventInfoSections";
import EventSidebar from "./EventSidebar";
import { BackButton } from "@ic-anywhere/ic-components";
import { Loader } from "@access-selfcare/shared-libs";
import { useGetMyInvitationsQuery } from "src/queries/useGetMyInvitationsQuery";

const EventDetail: React.FC = () => {
  const { id: eventId } = useParams<{ id: string }>();
  const accessCheck = useCheckEventAccess(eventId);
  const { data: eventDetail, isLoading } = useGetEventDetailQuery(eventId, accessCheck === "access");
  const { data: myInvitation, isLoading: isLoadingInvitation } = useGetMyInvitationsQuery(eventId);

  return (
    <div className="container-xxl" style={{ marginTop: "32px" }}>
      <div className="d-flex flex-column">
        <BackButton className="align-self-start" />
        <Loader containerClass={"d-flex justify-content-center"} isVisible={isLoading || isLoadingInvitation} />
        {eventDetail && myInvitation && (
          <>
            <span className="mt-4 text-secondary">{formatTitleHeader(capitalize(eventDetail?.event.category))}</span>
            <h1 className="mt-3 mb-3">{formatTitleHeader(capitalize(eventDetail?.event.name))}</h1>
            <div className="d-flex flex-row gap-4">
              <EventInfoSections
                pictureLink={eventDetail.event.pictureLink}
                name={eventDetail.event.name}
                description={eventDetail.event.description}
                usefulInformation={eventDetail.event.usefulInformation}
              />
              <EventSidebar event={eventDetail.event} eventInvitationStatus={myInvitation?.status} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EventDetail;
